import React from 'react'
import { Heading } from 'theme-ui'

/**
 * Shadow me to add your own content
 */

const styles = {
  heading: {
    fontSize: ['2em', '2.5em'],
    span: {
      color: `omegaDark`
    }
  }
}

export default () => (
  <Heading variant='h2' sx={styles.heading}>
    Retention. Gifting.
    <br />
    <span>We've got you covered.</span>
  </Heading>
)
